import { render } from "./DisplayBoard.vue?vue&type=template&id=3ba3372c"
import script from "./DisplayBoard.vue?vue&type=script&lang=js"
export * from "./DisplayBoard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erik/code/oliebol/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__